import { RolexContainer } from '@components/_rolex/Container'
import { Image } from '@components/gassan-ui'
import { Button } from '@components/rolex-ui/Button'
import { Heading } from '@components/rolex-ui/Heading'
import { cn } from '@lib/cn'
import { getKontentImage } from '@lib/kontent'
import { AssetsElement } from '@lib/kontent/models/Elements'
import { useTranslation } from 'next-i18next'
import React, { FC } from 'react'
import { getLocalePrefix } from '@lib/get-locale-prefix'

type LandingPageHeroProps = {
  mobileImage: AssetsElement
  desktopImage: AssetsElement
  title: string
  buttonText: string
}

export const LandingPageHero: FC<LandingPageHeroProps> = ({
  mobileImage,
  desktopImage,
  title,
  buttonText,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation('navigation')
  const localizedHref = `${getLocalePrefix(language)}${t(`rcpo.selection.url`, {
    ns: 'navigation',
  })}`
  return (
    <div className={cn('relative')}>
      <Image
        className="aspect-[13/20] w-full object-cover md:aspect-[12/5]"
        sources={[
          getKontentImage(mobileImage.value[0].url, { width: 768 }),
          getKontentImage(desktopImage.value[0].url, { width: 1200 }),
          getKontentImage(desktopImage.value[0].url, { width: 2000 }),
        ]}
        alt={mobileImage.value[0].description || title}
      />
      <RolexContainer className="absolute bottom-8 left-0 right-0 z-[2] grid w-full grid-cols-12 md:bottom-auto md:top-1/2 md:-translate-y-1/2">
        <div className={cn('col-span-12', 'md:col-span-5')}>
          <Heading variant="headline70" as="h1" className="!mb-5 text-white">
            {title}
          </Heading>
          <Button
            as="link"
            href={localizedHref}
            variant="primary"
            className="w-fit focus:outline-none focus:ring-2 focus:ring-rolexOceanGreen"
          >
            {buttonText}
          </Button>
        </div>
      </RolexContainer>
    </div>
  )
}
